import logoFull from '@/assets/frage_walter_match_logo.svg'
import Image from 'next/image'

export const LogoFullSizable = ({
    mb = 'mb-6',
    h = 'h-16 xl:h-18',
    mauto = 'm-auto',
}: {
    mb?: string
    h?: string
    mauto?: string
}) => {
    return (
        <Image
            src={logoFull}
            alt="Walter Logo"
            className={`${h} w-auto${mauto ? ' ' + mauto : ''}${mb ? ' ' + mb : ''}`}
        />
    )
}
